module.exports = __webpack_public_path__ + "img/high_performance.d4215463.svg";